import { IStore } from '../../index'

export default function(state: IStore) {
  return state.search.drawerRef
}
